import styled from '@emotion/styled/macro';
import { Variables } from '../base';

export const TrackContainer = styled.section<{ $isPaused: boolean }>`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    border-radius: 999px;
    overflow: hidden;
    border: 1px solid ${Variables.Colors.n15};
    background: ${Variables.ThemeLight.BackgroundB1};
    margin: 0;
    pointer-events: ${({ $isPaused }) => ($isPaused ? 'auto' : 'none')};
`;

export const TrackStep = styled.div<{ $isCompleted: boolean; $isCurrent: boolean; $isPaused: boolean }>`
    position: relative;
    z-index: ${({ $isCurrent }) => ($isCurrent ? 2 : 1)};
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 46px;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    user-select: none;
    background: ${({ $isCompleted, $isCurrent }) =>
        $isCurrent
            ? `linear-gradient(
                to right,
                ${Variables.ThemeLight.PrimaryMild1} 0%,
                ${Variables.ThemeLight.PrimaryMild1} 50%,
                ${Variables.ThemeLight.BackgroundB1} 50%,
                ${Variables.ThemeLight.BackgroundB1} 100%
            )`
            : $isCompleted
              ? Variables.ThemeLight.PrimaryMild1
              : Variables.ThemeLight.BackgroundB1};
    color: ${({ $isCurrent, $isPaused }) =>
        $isCurrent
            ? $isPaused
                ? Variables.ThemeLight.TextMedium
                : Variables.Colors.white
            : Variables.ThemeLight.TextMedium};

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: ${({ $isCurrent }) => ($isCurrent ? '999px' : '0')};
        background: ${({ $isCurrent, $isPaused }) =>
            $isCurrent
                ? $isPaused
                    ? Variables.ThemeLight.NeutralInverted8
                    : Variables.ThemeLight.PrimaryConstant6
                : 'transparent'};
        box-shadow: ${({ $isCurrent }) => ($isCurrent ? '0 2px 6px rgba(0,0,0,0.15)' : 'none')};
        z-index: 0;
    }
`;

export const StepContent = styled.span`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.2;
`;

export const StepLabel = styled.span`
    display: block;
`;

export const StepSubtitle = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    white-space: normal;
`;
